import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { PageTitle } from './PageTitle.jsx';

import { useApplication } from '../AppContext';

const About = () => {
	const app = useApplication();
	const { t } = useTranslation();

	const showSendEmail = app.showEmail;
	const showMoreGames = app.showMoreGames;
	const showRateGame = app.showRateGame;

	const rateGame = React.useCallback(() => {
		app.rateGame();
	}, [app]);

	const share = React.useCallback(() => {
		app.share();
	}, [app]);

	const email = React.useCallback(() => {
		app.email();
	}, [app]);

	return (
		<div id="About1" className="page">
			<div className="wrapper">
				<PageTitle>
					<h1>{t('About')}</h1>
				</PageTitle>
				{showSendEmail && (
					<div>
						<a onClick={email} className="list-button">
							<i className="ui-icon ui-mail" />
							{t('Send Feedback')}
						</a>
					</div>
				)}
				{showRateGame && (
					<div>
						<a onClick={rateGame} className="list-button" >
							<i className="ui-icon ui-favs" />
							{t('Rate Game')}
						</a>
					</div>
				)}
				<div>
					<a onClick={share} className="list-button" >
						<i className="ui-icon ui-share" />
						{t('Share')}
					</a>
				</div>
				{showMoreGames && (
					<div>
						<a href="#MoreGames" className="list-button">
							<i className="ui-icon ui-game" />
							{t('More Games')}
						</a>
					</div>
				)}
				<div className="text-center">
					{app.config.email}
				</div>
				<div className="text-center">
					<p>
						Privacy Policy:
						<a
							href="https://jdsoftwarellc.com/privacy"
							target="_blank"
							rel="noreferrer"
						>
							https://jdsoftwarellc.com/privacy
						</a>
					</p>
				</div>
			</div>
		</div>
	);
};

export default About;
